import { render } from "./SessionSetup.vue?vue&type=template&id=374f70c5&ts=true"
import script from "./SessionSetup.vue?vue&type=script&lang=ts"
export * from "./SessionSetup.vue?vue&type=script&lang=ts"

import "./SessionSetup.vue?vue&type=style&index=0&id=374f70c5&lang=scss"

import exportComponent from "/home/node/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__